
import { Component, ChangeDetectionStrategy, input } from '@angular/core';
// FIX: Corrected import path for models.
import { Kpi } from '../../models/index';
import { TranslatePipe } from '../../pipes/translate.pipe';
// FIX: Replaced deprecated `NumberPipe` with `DecimalPipe`.
import { CurrencyPipe, PercentPipe, DecimalPipe } from '@angular/common';

@Component({
  selector: 'app-kpi-card',
  standalone: true,
  templateUrl: './kpi-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  // FIX: Replaced deprecated `NumberPipe` with `DecimalPipe`.
  imports: [TranslatePipe, CurrencyPipe, PercentPipe, DecimalPipe]
})
export class KpiCardComponent {
  kpi = input.required<Kpi>();
}
